document.addEventListener('DOMContentLoaded', function () {
  const track = document.querySelector('.carousel-track');
  const slides = document.querySelectorAll('.carousel-image');
  const leftArrow = document.querySelector('.left-arrow');
  const rightArrow = document.querySelector('.right-arrow');
  let position = 0;

  function updateCarousel() {
    track.style.transform = `translateX(-${position * 100}%)`;
  }

  if (leftArrow && rightArrow && slides.length > 1) {
    leftArrow.addEventListener('click', () => {
      if (position > 0) {
        position--;
        updateCarousel();
      }
    });

    rightArrow.addEventListener('click', () => {
      if (position < slides.length - 1) {
        position++;
        updateCarousel();
      }
    });
  }

  // Swipe support for mobile
  let startX = 0;

  track.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
  });

  track.addEventListener('touchend', (e) => {
    const endX = e.changedTouches[0].clientX;
    if (startX - endX > 50 && position < slides.length - 1) {
      position++;
    } else if (endX - startX > 50 && position > 0) {
      position--;
    }
    updateCarousel();
  });
});
